import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/rootReducer";
import userStorage from "store/UserStorage";
import { ProductCartItem, CartState } from "./types";

const initialState: CartState = {
  currentStep: 1,
  reload: false,
};

const cart = createSlice({
  name: "cartSlice",
  initialState,
  reducers: {
    setReload(state, action) {
      state.reload = action.payload;
    },

    setCurrentStep(state, action) {
      state.currentStep = action.payload;
    },
  },
});
export const { setReload, setCurrentStep } = cart.actions;
export const selectCurrentStep = (state: RootState) => state.cart.currentStep;
export const selectCartReload = (state: RootState) => state.cart.reload;

export const updateCartData = (data: ProductCartItem[]) => async (
  dispatch: any
) => {
  dispatch(setReload(true));
  userStorage.updateCartItems(data);
  let _count = 0;
  let totalPriceWithoutDiscount = 0;
  let totalPriceWithDiscount = 0;
  data.forEach((item) => {
    const itemCount = item.count ? item.count : 1;
    let priceWithDiscount = item.product.price_promotion
      ? item.product.price_promotion
      : item.product.price;
    let priceWithoutDiscount = item.product.price;
    totalPriceWithoutDiscount =
      totalPriceWithoutDiscount + priceWithoutDiscount * itemCount;
    totalPriceWithDiscount =
      totalPriceWithDiscount + priceWithDiscount * itemCount;
    _count = itemCount + _count;
  });
  userStorage.updateTotalPriceWithDiscount(totalPriceWithDiscount);
  userStorage.updateTotalPriceWithoutDiscount(totalPriceWithoutDiscount);
  userStorage.updateTotalSelectedItems(_count);
  dispatch(setReload(false));
};
export default cart.reducer;
